import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { generateHistoricsPDF } from 'lib/pdfs/HistoricsPDF'; // ******** create pdf file to insouts

import { acceptHistoric, rejectHistoric } from 'containers/assets/actions';
import { addGrowlSuccess, addGrowlError } from 'messages/actions';
import * as Reports from 'reports/components';
import { getInsOutsReport } from 'reports/actions'; // *********** crear actions de insouts
import { getInsOutsReportPagination, getInsOutsReportFilters } from 'reports/selectors'; // ****** crear selectors insouts

import { getLocations } from 'selectors/lists';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import { getHistoricsIsSaving } from 'selectors/assets';

class InsOutsReportRow extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
  };

  state = { collapsed: true };

  fetch = () => {
    const { company, subcompany, pagination, filters } = this.props;

    this.props.getReport(
      company.id,
      subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounce = debounce(this.fetch, 200);

  handleToggleCollapsed = () => this.setState({ collapsed: !this.state.collapsed });

  handleGeneratePDF = (record) => generateHistoricsPDF(record, this.props.subcompany); // ***** crear pdf ionsouts file

  handleAccept = (record) => {
    this.props
      .accept(record.id, record._asset, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() => this.fetchDebounce())
      .catch((e) => this.props.error(e.message));
  };
  handleReject = (record) => {
    this.props
      .reject(record.id, record._asset, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() => this.fetchDebounce())
      .catch((e) => this.props.error(e.message));
  };

  render = () => (
    <Reports.InsOutsReportRow
      isSaving={this.props.isSaving}
      record={this.props.record}
      locations={this.props.locations}
      collapsed={this.state.collapsed}
      handleToggleCollapsed={this.handleToggleCollapsed}
      handleGeneratePDF={this.handleGeneratePDF}
      handleAccept={this.handleAccept}
      handleReject={this.handleReject}
    />
  );
}

const mapStateToProps = (state) => ({
  filters: getInsOutsReportFilters(state),
  locations: getLocations(state),
  pagination: getInsOutsReportPagination(state),
  isSaving: getHistoricsIsSaving(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});
const mapDispatchToProps = {
  getReport: getInsOutsReport,
  accept: acceptHistoric,
  reject: rejectHistoric,
  success: addGrowlSuccess,
  error: addGrowlError,
};

export default connect(mapStateToProps, mapDispatchToProps)(InsOutsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/InsOutsReportRowContainer.js